import React from 'react';
import { Box } from '@mui/material';
import ReviewItem from './ReviewItem';
import { Review } from '../../types/Review';

interface ReviewListProps {
  reviews: Review[];
  isListView?: boolean;
}

const ReviewList: React.FC<ReviewListProps> = ({ reviews, isListView = false }) => {
  return (
    <Box>
      {reviews.map((review) => (
        <ReviewItem key={review.id} review={review} isListView={isListView} />
      ))}
    </Box>
  );
};

export default ReviewList;